<style lang="scss" scoped>
.project {
  .project-title {
    margin-bottom: 30px;
    h4 {
      font-weight: 600;
    }
  }
  .project-title.project-employee-title {
    margin-top: 25px;
  }
  .create-form-project {
    width: 100%;

    .form-group {
      margin-bottom: 0;
    }

    .form-field {
      margin-bottom: 25px;
    }

    label {
      font-weight: 600;
    }

    .required {
      color: #ff1a1a;
    }

    .require {
      color: #ff1a1a;
    }

    .update-employee {
      clear: both;
      margin-left: 14px;
    }

    .information-employee {
      position: relative;
      clear: both;
    }

    .btn-delete-employee {
      margin-left: 10px;
      cursor: pointer;
    }

    .project-member {
      clear: both;
      width: 100%;
      padding-top: 20px;

      .form-field {
        display: inline-block;
      }

      .customer-information {
        margin-bottom: 20px;
      }
    }

    .btn-update-employee {
      clear: both;

      .btn-add-new label {
        color: #f6ab5f;
        font-size: 1rem;
        cursor: pointer;
      }
    }

    .project.button {
      clear: both;
      margin: 30px 0 50px 0;
      .save-project {
        background: #b4daf3;
        font-weight: 600;
        padding: 7px 70px;
        color: #0d2e48;
        border: 2px solid #b4daf3;
        margin-right: 20px;
      }

      .cancel-project {
        padding: 7px 45px;
        font-weight: 600;
        background: #f6f6f6;
        border: 2px solid #0d2e48;
        color: #0d2e48;
        max-width: 300px;
      }
    }
    .btn-add-range-time {
      label{
        cursor: pointer;
      }
    }
  }
}
@media (min-width: 768px) {
  .col-md-3 {
    flex: 0 0 33%;
    max-width: 35%;
  }
}
@media screen and (max-width: 767px) {
  .project {
    .create-form-project {
      margin-right: 0px;

      .save-project {
        width: 100%;
      }

      .cancel-project {
        width: 100%;
        max-width: 100% !important;
      }

      .project-left {
        clear: both;
        width: 100%;
      }

      .project-right {
        clear: both;
        width: 100%;
      }

      .information-employee {
        .delete-employee {
          right: 0%;
        }
      }
      .form-field {
        margin-bottom: 1rem;
      }

    }
  }
  .create-form-project .save-project,
  .create-form-project .cancel-project {
    width: 70%;
  }
  .project .create-form-project .project.button .save-project,
  .project .create-form-project .project.button .cancel-project {
    margin: 0 0 0.5rem 0;
    padding: 7px 0;
  }
}
</style>
<template>
  <div class="project">
    <CRow>
      <CCol md="12" sm="12" class="project-title">
        <h4>{{ $t("project.update_project") }}</h4>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12" sm="12">
          <CForm
            class="create-form-project"
            @submit.prevent="submitProject"
          >
            <CRow>
              <CCol md="3" sm="12" class="form-field">
                <label>
                  {{ $t("project.name_project") }}
                </label>
                <CInput type="text" v-model="project_info.name" />
              </CCol>
              <CCol md="3" sm="12" class="form-field">
                <label>
                  {{ $t("project.project_type") }}
                </label>
                <Select2
                    class="select2-custom"
                    v-model="project_info.project_type"
                    :options="types"
                  />
              </CCol>
              <CCol md="3" sm="12" class="form-field">
                <label>{{ $t("project.contract_value") }}</label>
                <CInput oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" v-model="project_info.contract_value" />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="3" sm="12" class="form-field">
                <label>
                  {{ $t("project.label_project_department_code") }}
                </label>
                <Select2
                    class="select2-custom"
                    v-model="project_info.department_code"
                    :options="departments"
                    @change="changeDepartment"
                  />
              </CCol>
              <CCol md="3" sm="12" class="form-field">
                <label>{{ $t("project.top_offshore") }}</label>
                <!-- <input class="form-control" :value="project_info.top_offshore_name" disabled />
                <input class="form-control" v-model="project_info.top_offshore" style="display: none" /> -->
                <Select2
                    class="select2-custom"
                    v-model="project_info.top_offshore"
                    :options="listTopOffshore"
                  />
              </CCol>
              <CCol md="3" sm="12" class="form-field">
                <label>{{ $t("project.pm") }}</label>
                <Select2
                    class="select2-custom"
                    v-model="project_info.pm"
                    :options="employees"
                  />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="3" sm="12" class="form-field">
                <label>
                  {{ $t("project.customer") }}
                </label>
                <Select2
                    class="select2-custom"
                    v-model="project_info.customer_id"
                    :options="customers"
                  />
              </CCol>
              <CCol md="3" sm="12" class="form-field">
                <label>
                  {{ $t("employee.label_project_status") }}
                </label>
                <Select2
                    class="select2-custom"
                    v-model="project_info.status"
                    :options="status"
                  />
              </CCol>
            </CRow>
            <CRow>
            </CRow>
            <CRow>
              <CCol
                md="12"
                sm="12"
                class="project button text-center button-mobile"
              >
                <CButton type="submit" class="save-project"
                >{{ $t("label.save_infomation") }}
                </CButton>
                <CButton class="cancel-project" type="button" @click="cancel()"
                >{{ $t("label.cancel_update_employee") }}
                </CButton>
              </CCol>
            </CRow>
          </CForm>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
// import DatePickerFormFlex from "@/components/Common/DatePickerFormFlex";
import api from '../../api/api';
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_project_update"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    // DatePickerFormFlex
  },
  data() {
    return {
      types: [
        {
          id: 1,
          text: "SPOT"
        },
        {
          id: 2,
          text: "LABO"
        },
        {
          id: 3,
          text: "MAINTAIN"
        },
        {
          id: 4,
          text: "OTHER"
        },
      ],
      listTopOffshore: [],
      status: [
        {
          id: "TODO",
          text: "Sắp triển khai"
        },
        {
          id: "DOING",
          text: "Đang triển khai"
        },
        {
          id: "DONE",
          text: "Đã hoàn thành"
        }
      ],
    };
  },
  async created() {
    await this.$store.dispatch("project/getCommonsData");
    this.idProject = this.$route.params.id;
    if (this.idProject) {
      await this.$store.dispatch("project/getInfoProject", this.idProject);
      await this.changeDepartment(this.project_info.department_code);
    }
    await this.getEmployeeAll();
  },

  computed: {
    ...mapGetters({
      project_info: "project/project_info",
      customers: "project/customers",
      project_status: "project/project_status",
      employee_position: "project/employee_position",
      foots: "commons/foots",
      divisions: "commons/divisions",
      developDivisions: "commons/developDivisions",
      parentDevelopDivistions: "commons/parentDevelopDivistions",
      qualityDivisions: "commons/qualityDivisions",
      employees: "project/getEmployees",
    }),
    departments() {
      return this.parentDevelopDivistions.map((item) => {
        item.id = item.code;
        return item;
      });
    }
  },

  methods: {
    ...mapActions("project", [
      "getEmployeeAll",
    ]),
    ...mapActions("layout", ["setLoading"]),

    startDate(data) {
      this.project_info.start_date = data;
      let employeeProject = this.project_info.employee_project
        ? this.project_info.employee_project
        : [];
      employeeProject.forEach(element => {
        element.member_project_start_date = this.project_info.start_date;
      });
    },

    endDate(data) {
      let employeeProject = this.project_info.employee_project ?? [];
      let listEmployee = employeeProject.filter(employee => {
        return employee.member_project_end_date === this.project_info.end_date || employee.member_project_end_date >= data
      })
      this.project_info.end_date = data;
      listEmployee.forEach(element => {
        element.member_project_end_date = this.project_info.end_date;
      });
    },

    rangeTimeStartDate(data, index, indexRangeTime) {
      this.project_info.employee_project[index].employee_range_time[indexRangeTime].member_project_start_date = data;
    },

    rangeTimeEndDate(data, index, indexRangeTime) {
      this.project_info.employee_project[index].employee_range_time[indexRangeTime].member_project_end_date = data;
    },

    memberProjectStartDate(data, index) {
      this.project_info.employee_project[index].member_project_start_date = data;
    },

    memberProjectEndDate(data, index) {
      this.project_info.employee_project[index].member_project_end_date = data;
    },

    async submitProject() {
      this.setLoading(true);
      await this.$store
      .dispatch("project/updateEmployee", this.project_info)
      .then(() => {
        let message = this.$t("project.popup.update_project_success");
        this.$toast(message, null, 2000, "b-toaster-top-center", "success");
        this.$router.push({ path: "/projects" });
        this.setLoading(false);
      })
      .catch(() => {
        this.setLoading(false);
      });
    },

    addEmployeeToProject() {
      this.project_info.employee_project.push({
        employee_id: "",
        employee_type: "",
        employee_skill_id: "",
        employee_list_skill: "",
        member_project_start_date: this.project_info.start_date,
        member_project_end_date: this.project_info.end_date,
        employee_range_time:[],
      });
    },

    deleteEmployeeFromProject(index) {
      this.project_info.employee_project.splice(index, 1);
    },

    cancel() {
      this.$confirm(
        this.$t("project.cancel_update_project"),
        this.$t("popup.employee.label_popup_title"),
        this.$t("popup.employee.label_confirm_button"),
        this.$t("popup.employee.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.$router.push({ path: "/projects" });
        }
      });
    },

    addEmployeeRangeTime(indexEmployee) {
      this.project_info.employee_project[indexEmployee].employee_range_time.push({
        member_project_start_date: this.project_info.start_date,
        member_project_end_date: this.project_info.end_date,
        effort:"",
      });
    },

    deleteRangeTime(indexRangeTime, indexEmployee) {
      this.project_info.employee_project[indexEmployee].employee_range_time.splice(indexRangeTime, 1);
    },

    async onChangeEmployee(employeeId, index) {
      this.setLoading(true);
      await this.$store
      .dispatch("project/getEmployeeSkill", employeeId)
      .then((response) => {
        this.$set(this.project_info.employee_project[index], 'employee_list_skill', response.data.employee_skill);
        this.$set(this.project_info.employee_project[index], 'employee_skill_id', '');
        this.setLoading(false);

      })
      .catch(() => {
        this.setLoading(false);
      });
    },
    async changeDepartment(department_code) {
      await axios.get(api.SHOW_EMPLOYEE + `/all?deparment_code=${department_code}`)
      .then((res) => {
        this.listTopOffshore = res.data;
      });
    },
  },

  watch: {
    employees(employeeList) {
      this.employee_list = employeeList.map((employee)=> {
        let splitSpaceString = employee.text.split(" ");
        let newStringEmail = splitSpaceString[splitSpaceString.length-1];
        let newStringName = splitSpaceString[splitSpaceString.length-2];
        let newArray = ((splitSpaceString.slice(0, splitSpaceString.length-2)).map(([i]) =>i)).join('');
        let numberPattern = /\d+/g;
        if(newStringEmail.match(numberPattern)=== null){
          return {
            id: employee.id,
            text: employee.name + " (" + newStringName + " " + newArray + ")"
          }
        }
        else {
          return {
            id: employee.id,
            text: employee.name + " (" + newStringName + " " + newArray + newStringEmail.match(numberPattern) + ")"
          }
        }
      })
    }
  }
};
</script>

<style scoped>
.delete-btn {
  color: red;
}

.select2-custom .select2-selection {
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  height: calc(1.5em + 0.75rem + 2px);
  display: block;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #d8dbe0;
  color: #768192;
  background-color: #fff;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.select2-custom .select2-selection:focus {
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
}

.select2-container {
  width: 100% !important;
}

/deep/ .form-control {
  color: #444444 !important;
  height: 40px !important;
}

</style>

<style lang="scss">
@media only screen and (max-device-width: 767px) {
  span.select2.select2-container.select2-container--default {
    width: 100% !important;
  }
}
.btn-submit {
  .btn-save {
    background: #118FA6;
    color: #EBF3F4;
  }
  .btn-cancel {
    background: #FFFFFF;
    color: #1F2D3D;
  }
  button {
    width: 172px;
    height: 49px;
    font-weight: 500;
  }
}
.select2-custom {
  .select2-selection {
    font-size: 0.875rem;
    font-weight: 400;
    // padding: 0.375rem 0.75rem;
    height: 40px;
    display: block;
    background-clip: padding-box;
    border: 1px solid #d8dbe0;
    color: #768192;
    background-color: #fff;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    .select2-selection__rendered {
      height: 40px;
      padding-top: 5px;
    }
    .select2-selection__arrow {
      height: 40px;
      padding: 4px 8px;
      width: 40px;
    }
  }
  .select2-selection:focus {
    color: #768192;
    background-color: #fff;
    border-color: #958bef;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
  }
}

.select2-search__field {
  border-radius: 5px;
}

.select2-container {
  width: 100% !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
